
import { db, doc, getDoc, collection, getDocs, query, where, limit, orderBy } from "../../firebaseClient";

export const TARGET_REQUEST_IDS = [
  'yWpx1dQQjWBN1wPhzutb',
  'lzc8BDrq68bhSQlXfC48',
  'mHILFSMOwg9hw8F9AjvE',
  'oF29616nibzJO3yWMkmi',
  'EOUAy3IPl90s2t4ZGdpA'
];

export interface FlowBundle {
  requestId: string;
  found: boolean;
  strategy: string;
  flowId?: string;
  flowPath?: string;
  data?: any;
  subcollections?: Record<string, any[]>;
  error?: string;
}

const SUBCOLLECTIONS = ['steps', 'history', 'actions', 'logs', 'comments'];

async function fetchSubcollections(flowDocRef: any): Promise<Record<string, any[]>> {
  const result: Record<string, any[]> = {};
  for (const sub of SUBCOLLECTIONS) {
    try {
      const snap = await getDocs(collection(flowDocRef, sub));
      if (!snap.empty) {
        result[sub] = snap.docs.map(d => ({ _id: d.id, ...d.data() }));
      }
    } catch (e) {
      // Ignore permission errors or non-existent collections
    }
  }
  return result;
}

export async function exportApprovalFlowBundleByRequestId(requestId: string): Promise<FlowBundle> {
  const result: FlowBundle = { requestId, found: false, strategy: 'none' };
  const colRef = collection(db, "approvalFlows");

  try {
    let flowSnap: any = null;
    let strategy = "";

    // Strategy A: Direct ID (requestId is often used as flowId in some versions)
    if (!flowSnap) {
      const ref = doc(colRef, requestId);
      const snap = await getDoc(ref);
      if (snap.exists) {
        flowSnap = snap;
        strategy = "A_DirectID";
      }
    }

    // Strategy A.1: Common Prefixes
    if (!flowSnap) {
        const prefixes = ["contractDraft", "CONTRACT_REVIEW", "sealRequest", "SEAL_REQUEST"];
        for (const pre of prefixes) {
            const id = `${pre}_${requestId}`;
            const snap = await getDoc(doc(colRef, id));
            if (snap.exists) {
                flowSnap = snap;
                strategy = `A1_Prefix_${pre}`;
                break;
            }
        }
    }

    // Strategy B: Where Query
    if (!flowSnap) {
      const fields = ["requestId", "targetId", "formId", "sourceId"];
      for (const field of fields) {
        const q = query(colRef, where(field, "==", requestId), limit(1));
        const snap = await getDocs(q);
        if (!snap.empty) {
          flowSnap = snap.docs[0];
          strategy = `B_Query_${field}`;
          break;
        }
      }
    }

    // Strategy C: Fallback Scan (Expensive, limited to debug)
    if (!flowSnap) {
      // Scan last 300 updated items
      const q = query(colRef, orderBy("updatedAt", "desc"), limit(300));
      const snap = await getDocs(q);
      for (const d of snap.docs) {
        const txt = JSON.stringify(d.data());
        if (txt.includes(requestId)) {
          flowSnap = d;
          strategy = "C_FallbackScan";
          break;
        }
      }
    }

    if (flowSnap) {
      result.found = true;
      result.strategy = strategy;
      result.flowId = flowSnap.id;
      result.flowPath = flowSnap.ref.path;
      result.data = flowSnap.data();
      result.subcollections = await fetchSubcollections(flowSnap.ref);
    } else {
      result.strategy = "not_found";
    }

  } catch (e: any) {
    result.error = e.message;
  }

  return result;
}

